"use client";
import { interFont } from "@/components/font/interFont.js";
import { ReactQueryProvider } from "@/components/ReactQueryProvider.js";
import { AccessibilityProvider } from "@rosette/web_components/src/accessibility/AccessibilityContext.js";
import Header from "@/components/layout/Header.js";
import Footer from "@/components/layout/Footer.js";
import { Button } from "@rosette/web_components/src/ui/Button.js";


export default function GlobalError() {
    const handleReload = () => window.location.reload();

    return (
        <html lang="en">
            <body className={`${interFont.className}`}>
                <ReactQueryProvider>
                    <AccessibilityProvider>
                        <Header />
                        <main className="w-full h-full py-4 px-0">
                            <section className="mx-auto max-w-3xl pb-9">
                                <h2 className="text-center mb-9">Sorry, something went wrong!</h2>
                                <div className="flex flex-row flex-wrap items-center justify-center gap-4">
                                    <Button tone="accent" size="lg" href="/">
                                        Back to Home
                                    </Button>
                                    <Button size="lg" onClick={handleReload}>
                                        Reload
                                    </Button>
                                </div>
                            </section>
                        </main>
                        <Footer />
                    </AccessibilityProvider>
                </ReactQueryProvider>
            </body>
        </html>
    );
}
